export const transactionResponse = {
  success: false,
  status: 'fail',
  result: null,
  fieldsErrors: null,
  messageError: null,
};

export const fileResponse = {
  ar: '',
  ie: '',
  dt: '',
  bl: false,
  dtl: new Array(detailResponse),
};

export const detailResponse = {
  cr: '',
  na: '',
  ca: '',
  ea: '',
  st: false,
  selected: false,
};
